// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"63ed94cf","602":"59a85a49"}[chunkId] + ".chunk.js";
};